export function getCssVariableValue(variableName: string): string {
  const rootStyles = getComputedStyle(document.documentElement);
  return rootStyles.getPropertyValue(variableName).trim();
}

export function setCssVariableValue(variableName: string, value: string): void {
  document.documentElement.style.setProperty(variableName, value);
}
